function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import React, { useState } from 'react';
import PropTypes from 'prop-types';
import IconButton from '@material-ui/core/IconButton';
import Tooltip from '@material-ui/core/Tooltip';
import MoreVertIcon from '@material-ui/icons/MoreVert';
import Popover from '@material-ui/core/Popover';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import List from '@material-ui/core/List';
import { Divider } from '@material-ui/core';
import Typography from '@material-ui/core/Typography';
export var Action = function Action(_ref) {
  var action = _ref.action,
      row = _ref.row,
      vertical = _ref.vertical,
      setAnchorEl = _ref.setAnchorEl;
  var icon = action.icon,
      tooltip = action.tooltip,
      onClick = action.onClick,
      label = action.label,
      _action$bottomDivider = action.bottomDivider,
      bottomDivider = _action$bottomDivider === void 0 ? false : _action$bottomDivider,
      labelColor = action.labelColor;

  var onClickButton = function onClickButton(event) {
    if (onClick) {
      onClick(row, event);

      if (setAnchorEl) {
        setAnchorEl(null);
      }
    }

    event.stopPropagation();
  };

  var button = vertical ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(ListItem, {
    button: true,
    onClick: onClickButton
  }, icon && /*#__PURE__*/React.createElement(ListItemIcon, null, icon), /*#__PURE__*/React.createElement(ListItemText, {
    disableTypography: true,
    primary: /*#__PURE__*/React.createElement(Typography, {
      type: "body2",
      style: labelColor ? {
        color: labelColor
      } : undefined
    }, label)
  })), bottomDivider && /*#__PURE__*/React.createElement(Divider, null)) : /*#__PURE__*/React.createElement(IconButton, {
    onClick: onClickButton
  }, icon, " ", label);

  if (tooltip) {
    return /*#__PURE__*/React.createElement(Tooltip, {
      title: tooltip
    }, button);
  }

  return button;
};
export function getActionButtons(actions) {
  var vertical = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  var row = arguments.length > 2 ? arguments[2] : undefined;
  var setAnchorEl = arguments.length > 3 ? arguments[3] : undefined;
  return actions.filter(function (action) {
    return !action.visible || !!row && action.visible(row);
  }).map(function (action, index) {
    return /*#__PURE__*/React.createElement(Action, {
      vertical: vertical // Commented rule of no-array-index-key because in the array of actions this is not necessary
      // eslint-disable-next-line
      ,
      key: "action-".concat(index),
      action: action,
      row: row,
      setAnchorEl: setAnchorEl
    });
  });
}

var RowActions = function RowActions(_ref2) {
  var actions = _ref2.actions,
      row = _ref2.row,
      _ref2$verticalActions = _ref2.verticalActions,
      verticalActions = _ref2$verticalActions === void 0 ? false : _ref2$verticalActions,
      forceCollapseActions = _ref2.forceCollapseActions;

  var _useState = useState(null),
      _useState2 = _slicedToArray(_useState, 2),
      anchorEl = _useState2[0],
      setAnchorEl = _useState2[1];

  var actionButtons = getActionButtons(actions, verticalActions, row, setAnchorEl);
  var open = Boolean(anchorEl);
  var returnEmpty = actionButtons.length === 0;

  if (returnEmpty || actions.length < 4 && !forceCollapseActions && !verticalActions) {
    return actionButtons;
  }

  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(IconButton, {
    onClick: function onClick(event) {
      event.preventDefault();
      event.stopPropagation();
      setAnchorEl(event.currentTarget);
    },
    "aria-owns": open ? 'simple-popper' : undefined,
    "aria-haspopup": "true"
  }, /*#__PURE__*/React.createElement(MoreVertIcon, null)), /*#__PURE__*/React.createElement(Popover, {
    open: open,
    anchorEl: anchorEl,
    onClose: function onClose(event) {
      event.preventDefault();
      event.stopPropagation();
      setAnchorEl(null);
    },
    anchorOrigin: {
      vertical: 'top',
      horizontal: 'left'
    },
    transformOrigin: {
      vertical: 'center',
      horizontal: 'right'
    }
  }, verticalActions ? /*#__PURE__*/React.createElement(List, {
    disablePadding: true
  }, actionButtons) : actionButtons));
};

RowActions.defaultProps = {
  row: null,
  forceCollapseActions: false
};
RowActions.propTypes = {
  actions: PropTypes.arrayOf(PropTypes.shape({
    tooltip: PropTypes.string,
    icon: PropTypes.object,
    onClick: PropTypes.func,
    visible: PropTypes.func
  })).isRequired,
  row: PropTypes.object,
  forceCollapseActions: PropTypes.bool
};
export default RowActions;